export const ADD_USER = 'ADD_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_OTP = 'SET_OTP';
export const RESET_OTP = 'RESET_OTP';
export const UPDATE_COUNT = 'UPDATE_COUNT';
export const FINAL_COUNT = 'FINAL_COUNT';